var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0773 14.5881V8.7608C16.0773 8.35538 15.9936 7.95422 15.8312 7.58189C15.6687 7.20956 15.4311 6.8739 15.1327 6.59548L9.57446 1.40707C9.29452 1.14565 8.92389 1 8.53865 1C8.15341 1 7.78278 1.14565 7.50284 1.40707L1.94459 6.59548C1.64623 6.8739 1.40856 7.20956 1.24614 7.58189C1.08371 7.95422 0.999956 8.35538 1 8.7608V14.5881C1 14.9831 1.15885 15.3618 1.4416 15.6411C1.72436 15.9204 2.10786 16.0773 2.50773 16.0773H14.5696C14.9694 16.0773 15.3529 15.9204 15.6357 15.6411C15.9185 15.3618 16.0773 14.9831 16.0773 14.5881Z",
    stroke: "#0B7770",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.cf0ab4355f7788469323f9e42a9f1afd.svg";
export { ForwardRef as ReactComponent };